import React, { useEffect, useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../../api';
import { AuthContext } from './AuthContext';
import './Login.css';
import logo from '../../assets/logo.png';

const LoginWithToken = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { setIsAuthenticated, setUser } = useContext(AuthContext);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);

    // Extraire le token des paramètres de l'URL
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    useEffect(() => {
        const verifyToken = async () => {
            if (!token) {
                setError('No login token provided. Please check your email link or request a new one.');
                setLoading(false);
                return;
            }

            try {
                const response = await api.get(`/login_with_token/${token}`);
                localStorage.setItem('token', response.data.access_token);
                
                // Update authentication context
                setIsAuthenticated(true);
                
                // Get user info
                try {
                    const userResponse = await api.get('/user_info');
                    setUser(userResponse.data);
                    // Redirection après un court délai pour laisser le temps de voir le message de succès
                    setTimeout(() => {
                        navigate('/create');
                    }, 1000);
                } catch (userError) {
                    console.error('Error fetching user data:', userError);
                    // Même si on n'a pas pu récupérer les infos utilisateur, l'authentification a fonctionné
                    setTimeout(() => {
                        navigate('/create');
                    }, 1000);
                }
            } catch (error) {
                console.error('Login error:', error);
                
                // Gestion des erreurs selon le code HTTP
                if (error.response) {
                    switch (error.response.status) {
                        case 401:
                            setError('Invalid or expired login link. Please request a new one.');
                            break;
                        case 500:
                            setError('Server error. Please try again later or contact support.');
                            break;
                        default:
                            setError(error.response.data?.msg || 'Error during login. Please try again.');
                    }
                } else {
                    setError('Network error. Please check your connection and try again.');
                }
                setLoading(false);
            }
        };

        verifyToken();
    }, [token, navigate, setIsAuthenticated, setUser]);

    const handleGoToLogin = () => {
        navigate('/login');
    };

    if (loading) {
        return (
            <div className="login-page">
                <div className="login-container">
                    <img src={logo} alt="AIvatar Logo" className="login-logo" />
                    <h2>Logging in...</h2>
                    <p>Please wait while we verify your login link</p>
                    <div className="loading-indicator">
                        <div className="spinner"></div>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="login-page">
                <div className="login-container">
                    <img src={logo} alt="AIvatar Logo" className="login-logo" />
                    <h2>Login Error</h2>
                    <div className="error-message">
                        {error}
                        <div className="error-action">
                            <button className="button-link" onClick={handleGoToLogin}>
                                Back to login
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="login-page">
            <div className="login-container">
                <img src={logo} alt="AIvatar Logo" className="login-logo" />
                <h2>Login Successful!</h2>
                <div className="success-message">
                    You have been logged in successfully. Redirecting to the application...
                </div>
            </div>
        </div>
    );
};

export default LoginWithToken;
